// src/index.tsx
import { jsx } from "react/jsx-runtime";
function CSideScript({
  scriptURLOverride,
  options,
  ...scriptProperties
}) {
  return /* @__PURE__ */ jsx(
    "script",
    {
      ...scriptProperties,
      src: scriptURLOverride ?? "https://proxy.csidetm.com/script.js",
      "data-options": JSON.stringify({
        ENABLE_FIRST_PARTY_PROXY: options?.enableProxyFirstPartyScripts,
        ENABLE_SCRIPT_TRACKING: options?.enableScriptTracking,
        ENABLE_SECURITY_HEADERS_CHECK: options?.enableSecurityHeadersCheck,
        EXCLUDED_SCRIPTS: options?.excludedScripts,
        SHOW_WELCOME_MESSAGE: options?.showWelcomeMessage,
        ...options
      }),
      async: false,
      defer: false
    }
  );
}
export {
  CSideScript
};
